export default function safeSetItem(key, item) {
	try {
		localStorage.setItem(key, item);
	} catch (e) {} // eslint-disable-line no-empty
}
